import { ParagraphProps } from "./types";
import { Paragraph } from "./styled-components";

export { Paragraph };
export type { ParagraphProps };
export default Paragraph;
